 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"banners-page~bulletin-page~children-page~contact-page~donate-page~error~events-page~foundation-page~~4705ee1a":"banners-page~bulletin-page~children-page~contact-page~donate-page~error~events-page~foundation-page~~4705ee1a","banners-page~bulletin-page~children-page~contact-page~donate-page~events-page~foundation-page~layout~72dff670":"banners-page~bulletin-page~children-page~contact-page~donate-page~events-page~foundation-page~layout~72dff670","banners-page~bulletin-page~contact-page":"banners-page~bulletin-page~contact-page","banners-page~contact-page~layout-default":"banners-page~contact-page~layout-default","banners-page":"banners-page","contact-page":"contact-page","bulletin-page~layout-default":"bulletin-page~layout-default","bulletin-page":"bulletin-page","layout-default":"layout-default","children-page~events-page~foundation-page~luanda-page~mupa-page~projects-page~starter-page~story-page":"children-page~events-page~foundation-page~luanda-page~mupa-page~projects-page~starter-page~story-page","children-page~projects-page~story-page":"children-page~projects-page~story-page","children-page":"children-page","projects-page":"projects-page","story-page":"story-page","events-page":"events-page","foundation-page":"foundation-page","luanda-page":"luanda-page","mupa-page":"mupa-page","starter-page":"starter-page","donate-page":"donate-page","news-page":"news-page","scholarships-page":"scholarships-page","solar-page":"solar-page","sponsorships-page":"sponsorships-page","error":"error","layout-error":"layout-error"}[chunkId]||chunkId) + "." + {"banners-page~bulletin-page~children-page~contact-page~donate-page~error~events-page~foundation-page~~4705ee1a":"77214e07","banners-page~bulletin-page~children-page~contact-page~donate-page~events-page~foundation-page~layout~72dff670":"4095a049","banners-page~bulletin-page~contact-page":"a1a6658c","banners-page~contact-page~layout-default":"1dab722f","banners-page":"52e3d33f","contact-page":"9bd5c6c7","bulletin-page~layout-default":"56d8091b","bulletin-page":"c646a191","layout-default":"dd149b9e","children-page~events-page~foundation-page~luanda-page~mupa-page~projects-page~starter-page~story-page":"cd45ed8e","children-page~projects-page~story-page":"a1807fa2","children-page":"b1c813d5","projects-page":"7a3ba981","story-page":"a90f8406","events-page":"4ccaf4af","foundation-page":"183624ae","luanda-page":"ab73343d","mupa-page":"e92034a7","starter-page":"f0ae9c05","donate-page":"0c12bfb0","news-page":"85baec20","scholarships-page":"3d09dbb8","solar-page":"9f31b168","sponsorships-page":"6575f62c","error":"13d32f54","layout-error":"beb00313"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"banners-page~bulletin-page~children-page~contact-page~donate-page~error~events-page~foundation-page~~4705ee1a":1,"banners-page~bulletin-page~children-page~contact-page~donate-page~events-page~foundation-page~layout~72dff670":1,"banners-page~bulletin-page~contact-page":1,"banners-page~contact-page~layout-default":1,"banners-page":1,"contact-page":1,"bulletin-page~layout-default":1,"bulletin-page":1,"layout-default":1,"children-page~events-page~foundation-page~luanda-page~mupa-page~projects-page~starter-page~story-page":1,"children-page~projects-page~story-page":1,"events-page":1,"luanda-page":1,"mupa-page":1,"starter-page":1,"donate-page":1,"news-page":1,"scholarships-page":1,"solar-page":1,"sponsorships-page":1,"error":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"banners-page~bulletin-page~children-page~contact-page~donate-page~error~events-page~foundation-page~~4705ee1a":"banners-page~bulletin-page~children-page~contact-page~donate-page~error~events-page~foundation-page~~4705ee1a","banners-page~bulletin-page~children-page~contact-page~donate-page~events-page~foundation-page~layout~72dff670":"banners-page~bulletin-page~children-page~contact-page~donate-page~events-page~foundation-page~layout~72dff670","banners-page~bulletin-page~contact-page":"banners-page~bulletin-page~contact-page","banners-page~contact-page~layout-default":"banners-page~contact-page~layout-default","banners-page":"banners-page","contact-page":"contact-page","bulletin-page~layout-default":"bulletin-page~layout-default","bulletin-page":"bulletin-page","layout-default":"layout-default","children-page~events-page~foundation-page~luanda-page~mupa-page~projects-page~starter-page~story-page":"children-page~events-page~foundation-page~luanda-page~mupa-page~projects-page~starter-page~story-page","children-page~projects-page~story-page":"children-page~projects-page~story-page","children-page":"children-page","projects-page":"projects-page","story-page":"story-page","events-page":"events-page","foundation-page":"foundation-page","luanda-page":"luanda-page","mupa-page":"mupa-page","starter-page":"starter-page","donate-page":"donate-page","news-page":"news-page","scholarships-page":"scholarships-page","solar-page":"solar-page","sponsorships-page":"sponsorships-page","error":"error","layout-error":"layout-error"}[chunkId]||chunkId) + "." + {"banners-page~bulletin-page~children-page~contact-page~donate-page~error~events-page~foundation-page~~4705ee1a":"2be92fc4","banners-page~bulletin-page~children-page~contact-page~donate-page~events-page~foundation-page~layout~72dff670":"378b551f","banners-page~bulletin-page~contact-page":"35518107","banners-page~contact-page~layout-default":"602f3fff","banners-page":"4eff6e85","contact-page":"483abf48","bulletin-page~layout-default":"dd7792b6","bulletin-page":"a69b52ba","layout-default":"9b5d96d3","children-page~events-page~foundation-page~luanda-page~mupa-page~projects-page~starter-page~story-page":"226e22f0","children-page~projects-page~story-page":"8fb67c6d","children-page":"31d6cfe0","projects-page":"31d6cfe0","story-page":"31d6cfe0","events-page":"dd6289d4","foundation-page":"31d6cfe0","luanda-page":"dd6289d4","mupa-page":"dd6289d4","starter-page":"36073b8f","donate-page":"af56a89d","news-page":"f069bf05","scholarships-page":"a55d78c7","solar-page":"fbe1b00e","sponsorships-page":"dfb8640c","error":"b486e69c","layout-error":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
